<template>
  <img
    v-if="themeToggel"
    src="../assets/images/netcorelogo-white.svg"
    :height="Number(height)"
    :width="Number(width)"
    alt="netcorelogo"
  />
  <img
    v-else
    src="../assets/images/netcorelogo.svg"
    :height="Number(height)"
    :width="Number(width)"
    alt="netcorelogo"
  />
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useDomainStore } from '@/stores/dashBoardStore.js'

const themeToggel = ref(false)
const domainStore = useDomainStore()

const props = defineProps(['height', 'width'])
console.log(props.height, props.width)

const setLogoOnTheme = () => {
  if (domainStore.theme === 'dark') {
    themeToggel.value = true
  } else {
    themeToggel.value = false
  }
}

watch(
  () => domainStore.theme,
  () => {
    setLogoOnTheme()
  },
)

onMounted(() => {
  setLogoOnTheme()
})
</script>
